import { __read } from "tslib";
import moment from 'moment';
import numberFormat from 'number-format.js';
import _get from 'lodash/get';
import _keys from 'lodash/keys';
function formatMoney(value) {
    return numberFormat('#,##0.00', value);
}
function formatDataRangeValue(value) {
    if (!value) {
        return;
    }
    if (value.start && value.end) {
        return [value.start, value.end];
    }
    if (value instanceof Array && value.length > 1) {
        return [value[0], value[1]];
    }
    return;
}
function formatDataRange(value, withTime) {
    var formatedValue = formatDataRangeValue(value);
    if (!formatedValue) {
        return '-';
    }
    var _a = __read(formatedValue, 2), start = _a[0], end = _a[1];
    if (!start || !end) {
        return '-';
    }
    var format = withTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
    var startText = moment(start).format(format);
    var endText = moment(end).format(format);
    return startText + " ~ " + endText;
}
function formatDate(value, withTime) {
    var format = withTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
    return moment(value).format(format);
}
function formatRef(value) {
    if (!value) {
        return '-';
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'object') {
        return value.name || value.label || '-';
    }
    return '-';
}
function stringifyCssStyle(style) {
    var keys = _keys(style);
    return "" + keys
        .map(function (key) {
        var value = style[key];
        return key + ": " + value + ";";
    })
        .join('');
}
export default function renderCell(column) {
    return function (value, data, index) {
        switch (column.dataType) {
            case 'ref':
                return "" + formatRef(value);
            case 'date':
                return "" + (value
                    ? formatDate(value, _get(column, 'property.withTime', false))
                    : '-');
            case 'dateRange':
                return "" + formatDataRange(value, _get(column, 'property.withTime', false));
            case 'number':
                return "" + (value || value === 0 ? value : '-');
            case 'money':
                return "" + (value ? formatMoney(value) : '-');
            default:
                return "" + (value || '-');
        }
    };
}
